import { $rqUsersApiClient } from "@/api/users"
import { getXOrganizationHeaders } from "@/api/utils"
import type { Space } from "@/types"

/**
 * Permission matrix of an organization space, kept for the session.
 * Never stale: it only changes with the user's role, which isn't refetched either. A failed one has no data,
 * so it is retried only when switching to that space (see app.tsx).
 * Organization spaces only: the private space has no organization header.
 */
export const policiesQuery = (spaceId: Space["id"]) =>
  $rqUsersApiClient.queryOptions(
    "get",
    "/users/v1/policies",
    { params: { header: getXOrganizationHeaders(spaceId)! } },
    // A failed matrix has no data, so it would count as stale: these keep it from refetching too.
    { gcTime: Infinity, staleTime: "static", retryOnMount: false, refetchOnWindowFocus: false, refetchOnReconnect: false }
  )
